import React, {useState, useCallback} from 'react';
import PatternRoll from './PatternRoll.js';
import { connect } from "react-redux";
import Step from 'components/track/Step.js';
import {getScrollLeft} from './getScrollLeft.js';
import {getStepFromPosition} from './getStepFromPosition.js';
import {DEFAULT_RESOLUTION} from './constants.js';
import {setArrangementBottomMode}  from 'actions/index.js';
import {getBarWidth} from './getBarWidth.js';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import {dispatch} from 'session/operations/dispatch.js';
import {movePianoRollPattern} from 'session/operations/actions.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

function MiniPianoRoll(props) {
    const onMouseMove = useCallback((e) => {
        if (props.sequencerEngine.state.arrangement.patternDragging) {
            e.stopPropagation();
            let {patternDragging, offsetX} =
                props.sequencerEngine.state.arrangement.patternDragging;
            let x = e.pageX + getScrollLeft() - offsetX;
            let stepNumber = getStepFromPosition(x, props.resolution, undefined, props.xScale);
            dispatch(undefined, movePianoRollPattern(props.track, patternDragging, stepNumber));
        }
    }, [props.xScale]);
    
    return (
        <div onMouseMove={onMouseMove}>
          {props.track.patterns
              .filter((x, i) => i >= 1)
              .map((pattern, i) =>
                   <PatternRoll
                         key={'pattern-'+pattern.id}
                         sequencerEngine={props.sequencerEngine}
                         pattern={pattern}
                         track={props.track}
                         patternNumber={i+1}/>
                  )}
        </div>
    );
}


const mapStateToProps = (state, props) => {
    return {
        numPatterns: props.track.patterns.length,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setArrangementMode: (mode) => dispatch(setArrangementBottomMode(mode)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniPianoRoll);

